import React from 'react'

import { Card, CardContent } from '@mui/material'
import PlanBadge from 'features/customers/components/PlanBadge'
import { List } from 'immutable'
import { Link } from 'react-router-dom'
import { UrlProvider } from 'urls'

import { SimpleTable } from 'components/table'

const config = [
  {
    title: 'Customer Name',
    render: (customer: any) => (
      <Link to={UrlProvider.getUrl('customer', { id: customer.id, tab: '' })}>{customer.name}</Link>
    ),
  },
  {
    title: 'Website',
    field: 'website',
  },
  {
    title: 'Plan',
    render: ({ plan }) => <PlanBadge name={plan?.name} />,
  },
]

type UserCustomersProps = {
  customers?: any
}

const UserCustomers = ({ customers = List() }: UserCustomersProps) => {
  return (
    <Card>
      <CardContent>
        <SimpleTable config={config} data={customers} />
      </CardContent>
    </Card>
  )
}

export default UserCustomers
